export default [
    {
        "id": 4,
        "name": "Action",
        "slug": "action",
        "games_count": 184606,
        "image_background": "https://media.rawg.io/media/games/34b/34b1f1850a1c06fd971bc6ab3ac0ce0e.jpg",
        "games": [
            {
                "id": 3498,
                "slug": "grand-theft-auto-v",
                "name": "Grand Theft Auto V",
                "added": 21694
            },
            {
                "id": 3328,
                "slug": "the-witcher-3-wild-hunt",
                "name": "The Witcher 3: Wild Hunt",
                "added": 21300
            },
            {
                "id": 5286,
                "slug": "tomb-raider",
                "name": "Tomb Raider (2013)",
                "added": 17402
            },
            {
                "id": 13536,
                "slug": "portal",
                "name": "Portal",
                "added": 17278
            },
            {
                "id": 12020,
                "slug": "left-4-dead-2",
                "name": "Left 4 Dead 2",
                "added": 17200
            },
            {
                "id": 5679,
                "slug": "the-elder-scrolls-v-skyrim",
                "name": "The Elder Scrolls V: Skyrim",
                "added": 16323
            }
        ]
    },
    {
        "id": 51,
        "name": "Indie",
        "slug": "indie",
        "games_count": 73373,
        "image_background": "https://media.rawg.io/media/games/0be/0bea0a08a4d954337305391b778a7f37.jpg",
        "games": [
            {
                "id": 1030,
                "slug": "limbo",
                "name": "Limbo",
                "added": 13829
            },
            {
                "id": 422,
                "slug": "terraria",
                "name": "Terraria",
                "added": 13225
            },
            {
                "id": 3272,
                "slug": "rocket-league",
                "name": "Rocket League",
                "added": 12684
            },
            {
                "id": 9767,
                "slug": "hollow-knight",
                "name": "Hollow Knight",
                "added": 11364
            },
            {
                "id": 3612,
                "slug": "hotline-miami",
                "name": "Hotline Miami",
                "added": 10707
            },
            {
                "id": 3790,
                "slug": "outlast",
                "name": "Outlast",
                "added": 10665
            }
        ]
    },
    {
        "id": 3,
        "name": "Adventure",
        "slug": "adventure",
        "games_count": 144413,
        "image_background": "https://media.rawg.io/media/games/942/9424d6bb763dc38d9378b488603c87fa.jpg",
        "games": [
            {
                "id": 3439,
                "slug": "life-is-strange-episode-1-2",
                "name": "Life is Strange",
                "added": 15633
            },
            {
                "id": 1030,
                "slug": "limbo",
                "name": "Limbo",
                "added": 13829
            },
            {
                "id": 23027,
                "slug": "the-walking-dead",
                "name": "The Walking Dead: Season 1",
                "added": 11475
            },
            {
                "id": 41,
                "slug": "little-nightmares",
                "name": "Little Nightmares",
                "added": 11392
            },
            {
                "id": 13668,
                "slug": "amnesia-the-dark-descent",
                "name": "Amnesia: The Dark Descent",
                "added": 10317
            },
            {
                "id": 9721,
                "slug": "garrys-mod",
                "name": "Garry's Mod",
                "added": 10295
            }
        ]
    },
    {
        "id": 5,
        "name": "RPG",
        "slug": "role-playing-games-rpg",
        "games_count": 58294,
        "image_background": "https://media.rawg.io/media/games/21c/21cc15d233117c6809ec86870559e105.jpg",
        "games": [
            {
                "id": 3328,
                "slug": "the-witcher-3-wild-hunt",
                "name": "The Witcher 3: Wild Hunt",
                "added": 21300
            },
            {
                "id": 5679,
                "slug": "the-elder-scrolls-v-skyrim",
                "name": "The Elder Scrolls V: Skyrim",
                "added": 16323
            },
            {
                "id": 802,
                "slug": "borderlands-2",
                "name": "Borderlands 2",
                "added": 15655
            },
            {
                "id": 3070,
                "slug": "fallout-4",
                "name": "Fallout 4",
                "added": 13927
            },
            {
                "id": 41494,
                "slug": "cyberpunk-2077",
                "name": "Cyberpunk 2077",
                "added": 13298
            },
            {
                "id": 766,
                "slug": "warframe",
                "name": "Warframe",
                "added": 12969
            }
        ]
    },
    {
        "id": 10,
        "name": "Strategy",
        "slug": "strategy",
        "games_count": 58592,
        "image_background": "https://media.rawg.io/media/games/0fa/0fadc446fd1e9ae9e23a32793d9a5406.jpg",
        "games": [
            {
                "id": 10243,
                "slug": "company-of-heroes-2",
                "name": "Company of Heroes 2",
                "added": 9809
            },
            {
                "id": 13633,
                "slug": "civilization-v",
                "name": "Sid Meier's Civilization V",
                "added": 9647
            },
            {
                "id": 11147,
                "slug": "ark-survival-of-the-fittest",
                "name": "ARK: Survival Of The Fittest",
                "added": 8852
            },
            {
                "id": 10065,
                "slug": "cities-skylines",
                "name": "Cities: Skylines",
                "added": 8536
            },
            {
                "id": 13910,
                "slug": "xcom-enemy-unknown",
                "name": "XCOM: Enemy Unknown",
                "added": 8422
            },
            {
                "id": 5525,
                "slug": "brutal-legend",
                "name": "Brutal Legend",
                "added": 8345
            }
        ]
    },
    {
        "id": 2,
        "name": "Shooter",
        "slug": "shooter",
        "games_count": 59541,
        "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg",
        "games": [
            {
                "id": 4200,
                "slug": "portal-2",
                "name": "Portal 2",
                "added": 20273
            },
            {
                "id": 4291,
                "slug": "counter-strike-global-offensive",
                "name": "Counter-Strike: Global Offensive",
                "added": 18067
            },
            {
                "id": 12020,
                "slug": "left-4-dead-2",
                "name": "Left 4 Dead 2",
                "added": 17200
            },
            {
                "id": 4062,
                "slug": "bioshock-infinite",
                "name": "BioShock Infinite",
                "added": 15777
            },
            {
                "id": 802,
                "slug": "borderlands-2",
                "name": "Borderlands 2",
                "added": 15655
            },
            {
                "id": 13537,
                "slug": "half-life-2",
                "name": "Half-Life 2",
                "added": 15587
            }
        ]
    },
    {
        "id": 40,
        "name": "Casual",
        "slug": "casual",
        "games_count": 58809,
        "image_background": "https://media.rawg.io/media/games/3ef/3eff92562640e452d3487c04ba6d7fae.jpg",
        "games": [
            {
                "id": 9721,
                "slug": "garrys-mod",
                "name": "Garry's Mod",
                "added": 10295
            },
            {
                "id": 326292,
                "slug": "fall-guys",
                "name": "Fall Guys: Ultimate Knockout",
                "added": 8801
            },
            {
                "id": 9830,
                "slug": "brawlhalla",
                "name": "Brawlhalla",
                "added": 8156
            },
            {
                "id": 356714,
                "slug": "among-us",
                "name": "Among Us",
                "added": 7744
            },
            {
                "id": 1959,
                "slug": "goat-simulator",
                "name": "Goat Simulator",
                "added": 6448
            },
            {
                "id": 817974,
                "slug": "wallpaper-engine",
                "name": "Wallpaper Engine",
                "added": 6444
            }
        ]
    },
    {
        "id": 14,
        "name": "Simulation",
        "slug": "simulation",
        "games_count": 72263,
        "image_background": "https://media.rawg.io/media/games/5f4/5f4780690dbf04900cbac5f05b9305f3.jpg",
        "games": [
            {
                "id": 10035,
                "slug": "hitman",
                "name": "Hitman",
                "added": 10732
            },
            {
                "id": 654,
                "slug": "stardew-valley",
                "name": "Stardew Valley",
                "added": 10624
            },
            {
                "id": 9721,
                "slug": "garrys-mod",
                "name": "Garry's Mod",
                "added": 10295
            },
            {
                "id": 9882,
                "slug": "dont-starve-together",
                "name": "Don't Starve Together",
                "added": 9786
            },
            {
                "id": 10065,
                "slug": "cities-skylines",
                "name": "Cities: Skylines",
                "added": 8536
            },
            {
                "id": 22509,
                "slug": "minecraft",
                "name": "Minecraft",
                "added": 8502
            }
        ]
    },
    {
        "id": 7,
        "name": "Puzzle",
        "slug": "puzzle",
        "games_count": 97320,
        "image_background": "https://media.rawg.io/media/games/cfe/cfe114c081281960bd79ace5209c0a4a.jpg",
        "games": [
            {
                "id": 4200,
                "slug": "portal-2",
                "name": "Portal 2",
                "added": 20273
            },
            {
                "id": 13536,
                "slug": "portal",
                "name": "Portal",
                "added": 17278
            },
            {
                "id": 1030,
                "slug": "limbo",
                "name": "Limbo",
                "added": 13829
            },
            {
                "id": 19709,
                "slug": "half-life-2-episode-two",
                "name": "Half-Life 2: Episode Two",
                "added": 11178
            },
            {
                "id": 1450,
                "slug": "inside",
                "name": "INSIDE",
                "added": 8144
            },
            {
                "id": 3853,
                "slug": "trine-2-complete-story",
                "name": "Trine 2: Complete Story",
                "added": 7380
            }
        ]
    },
    {
        "id": 11,
        "name": "Arcade",
        "slug": "arcade",
        "games_count": 22653,
        "image_background": "https://media.rawg.io/media/games/370/3703c683968a54f09630dcf03366ea35.jpg",
        "games": [
            {
                "id": 3612,
                "slug": "hotline-miami",
                "name": "Hotline Miami",
                "added": 10707
            },
            {
                "id": 17540,
                "slug": "injustice-gods-among-us-ultimate-edition",
                "name": "Injustice: Gods Among Us Ultimate Edition",
                "added": 9782
            },
            {
                "id": 22509,
                "slug": "minecraft",
                "name": "Minecraft",
                "added": 8502
            },
            {
                "id": 4003,
                "slug": "grid-2",
                "name": "GRID 2",
                "added": 7672
            },
            {
                "id": 3408,
                "slug": "hotline-miami-2-wrong-number",
                "name": "Hotline Miami 2: Wrong Number",
                "added": 6313
            },
            {
                "id": 58753,
                "slug": "forza-horizon-4",
                "name": "Forza Horizon 4",
                "added": 6183
            }
        ]
    },
    {
        "id": 83,
        "name": "Platformer",
        "slug": "platformer",
        "games_count": 100844,
        "image_background": "https://media.rawg.io/media/games/fd8/fd882c8267a44621a0de6f9cec77ae90.jpg",
        "games": [
            {
                "id": 1030,
                "slug": "limbo",
                "name": "Limbo",
                "added": 13829
            },
            {
                "id": 422,
                "slug": "terraria",
                "name": "Terraria",
                "added": 13225
            },
            {
                "id": 41,
                "slug": "little-nightmares",
                "name": "Little Nightmares",
                "added": 11392
            },
            {
                "id": 9767,
                "slug": "hollow-knight",
                "name": "Hollow Knight",
                "added": 11364
            },
            {
                "id": 3144,
                "slug": "super-meat-boy",
                "name": "Super Meat Boy",
                "added": 9592
            },
            {
                "id": 17572,
                "slug": "batman-aa-goty",
                "name": "Batman: Arkham Asylum Game of the Year Edition",
                "added": 8455
            }
        ]
    },
    {
        "id": 59,
        "name": "Massively Multiplayer",
        "slug": "massively-multiplayer",
        "games_count": 3915,
        "image_background": "https://media.rawg.io/media/games/d07/d0790809a13027251b6d0f4dc7538c58.jpg",
        "games": [
            {
                "id": 766,
                "slug": "warframe",
                "name": "Warframe",
                "added": 12969
            },
            {
                "id": 10213,
                "slug": "dota-2",
                "name": "Dota 2",
                "added": 12964
            },
            {
                "id": 10533,
                "slug": "path-of-exile",
                "name": "Path of Exile",
                "added": 10506
            },
            {
                "id": 10142,
                "slug": "playerunknowns-battlegrounds",
                "name": "PlayerUnknown’s Battlegrounds",
                "added": 10502
            },
            {
                "id": 362,
                "slug": "for-honor",
                "name": "For Honor",
                "added": 9599
            },
            {
                "id": 11147,
                "slug": "ark-survival-of-the-fittest",
                "name": "ARK: Survival Of The Fittest",
                "added": 8852
            }
        ]
    },
    {
        "id": 1,
        "name": "Racing",
        "slug": "racing",
        "games_count": 25171,
        "image_background": "https://media.rawg.io/media/games/d16/d160819f22de73d29813f7b6dad815f9.jpg",
        "games": [
            {
                "id": 3272,
                "slug": "rocket-league",
                "name": "Rocket League",
                "added": 12684
            },
            {
                "id": 4003,
                "slug": "grid-2",
                "name": "GRID 2",
                "added": 7672
            },
            {
                "id": 2572,
                "slug": "dirt-rally",
                "name": "DiRT Rally",
                "added": 6962
            },
            {
                "id": 58753,
                "slug": "forza-horizon-4",
                "name": "Forza Horizon 4",
                "added": 6183
            },
            {
                "id": 5578,
                "slug": "grid",
                "name": "GRID (2008)",
                "added": 5393
            },
            {
                "id": 19491,
                "slug": "burnout-paradise-the-ultimate-box",
                "name": "Burnout Paradise: The Ultimate Box",
                "added": 4815
            }
        ]
    },
    {
        "id": 15,
        "name": "Sports",
        "slug": "sports",
        "games_count": 21920,
        "image_background": "https://media.rawg.io/media/screenshots/f5a/f5abab52c4d606551cd5ec3ab709e501.jpg",
        "games": [
            {
                "id": 3272,
                "slug": "rocket-league",
                "name": "Rocket League",
                "added": 12684
            },
            {
                "id": 326292,
                "slug": "fall-guys",
                "name": "Fall Guys: Ultimate Knockout",
                "added": 8801
            },
            {
                "id": 2572,
                "slug": "dirt-rally",
                "name": "DiRT Rally",
                "added": 6962
            },
            {
                "id": 53341,
                "slug": "jet-set-radio-2012",
                "name": "Jet Set Radio",
                "added": 5275
            },
            {
                "id": 9575,
                "slug": "vrchat",
                "name": "VRChat",
                "added": 5064
            },
            {
                "id": 36,
                "slug": "tekken-7",
                "name": "TEKKEN 7",
                "added": 4131
            }
        ]
    },
    {
        "id": 6,
        "name": "Fighting",
        "slug": "fighting",
        "games_count": 11761,
        "image_background": "https://media.rawg.io/media/games/96b/96b9420bbd4bd1b79bf2a67f7779733a.jpg",
        "games": [
            {
                "id": 5286,
                "slug": "tomb-raider",
                "name": "Tomb Raider (2013)",
                "added": 17402
            },
            {
                "id": 17540,
                "slug": "injustice-gods-among-us-ultimate-edition",
                "name": "Injustice: Gods Among Us Ultimate Edition",
                "added": 9782
            },
            {
                "id": 108,
                "slug": "mortal-kombat-x",
                "name": "Mortal Kombat X",
                "added": 8891
            },
            {
                "id": 28179,
                "slug": "sega-mega-drive-and-genesis-classics",
                "name": "SEGA Mega Drive and Genesis Classics",
                "added": 8384
            },
            {
                "id": 9830,
                "slug": "brawlhalla",
                "name": "Brawlhalla",
                "added": 8156
            },
            {
                "id": 274480,
                "slug": "mortal-kombat-11",
                "name": "Mortal Kombat 11",
                "added": 5624
            }
        ]
    },
    {
        "id": 19,
        "name": "Family",
        "slug": "family",
        "games_count": 5404,
        "image_background": "https://media.rawg.io/media/games/a87/a8743bdee8627c55bb9f2f01b9136ac1.jpg",
        "games": [
            {
                "id": 3254,
                "slug": "journey",
                "name": "Journey",
                "added": 8486
            },
            {
                "id": 3729,
                "slug": "lego-the-hobbit",
                "name": "LEGO The Hobbit",
                "added": 5394
            },
            {
                "id": 3350,
                "slug": "broken-age",
                "name": "Broken Age",
                "added": 5110
            },
            {
                "id": 1259,
                "slug": "machinarium",
                "name": "Machinarium",
                "added": 4644
            },
            {
                "id": 1140,
                "slug": "world-of-goo",
                "name": "World of Goo",
                "added": 4539
            },
            {
                "id": 4331,
                "slug": "sonic-generations",
                "name": "Sonic Generations",
                "added": 4286
            }
        ]
    },
    {
        "id": 28,
        "name": "Board Games",
        "slug": "board-games",
        "games_count": 8383,
        "image_background": "https://media.rawg.io/media/screenshots/a73/a7362b567065a463164ba854fbed9aef.jpeg",
        "games": [
            {
                "id": 23557,
                "slug": "gwent-the-witcher-card-game",
                "name": "Gwent: The Witcher Card Game",
                "added": 4978
            },
            {
                "id": 327999,
                "slug": "dota-underlords",
                "name": "Dota Underlords",
                "added": 4218
            },
            {
                "id": 2055,
                "slug": "adventure-capitalist",
                "name": "AdVenture Capitalist",
                "added": 3544
            },
            {
                "id": 758,
                "slug": "hue",
                "name": "Hue",
                "added": 2759
            },
            {
                "id": 3187,
                "slug": "armello",
                "name": "Armello",
                "added": 2110
            },
            {
                "id": 2306,
                "slug": "poker-night-2",
                "name": "Poker Night 2",
                "added": 2102
            }
        ]
    },
    {
        "id": 34,
        "name": "Educational",
        "slug": "educational",
        "games_count": 15686,
        "image_background": "https://media.rawg.io/media/screenshots/31d/31d70d348acf9924a218ddcb80c171be.jpg",
        "games": [
            {
                "id": 1358,
                "slug": "papers-please",
                "name": "Papers, Please",
                "added": 7075
            },
            {
                "id": 1140,
                "slug": "world-of-goo",
                "name": "World of Goo",
                "added": 4539
            },
            {
                "id": 2778,
                "slug": "surgeon-simulator-cpr",
                "name": "Surgeon Simulator",
                "added": 4051
            },
            {
                "id": 9768,
                "slug": "gameguru",
                "name": "GameGuru",
                "added": 2665
            },
            {
                "id": 13777,
                "slug": "sid-meiers-civilization-iv-colonization",
                "name": "Sid Meier's Civilization IV: Colonization",
                "added": 2412
            },
            {
                "id": 6885,
                "slug": "pirates-3",
                "name": "Sid Meier's Pirates!",
                "added": 2333
            }
        ]
    },
    {
        "id": 17,
        "name": "Card",
        "slug": "card",
        "games_count": 4536,
        "image_background": "https://media.rawg.io/media/screenshots/40f/40fee8fed4bc26960004731a549578eb.jpeg",
        "games": [
            {
                "id": 28121,
                "slug": "slay-the-spire",
                "name": "Slay the Spire",
                "added": 5114
            },
            {
                "id": 23557,
                "slug": "gwent-the-witcher-card-game",
                "name": "Gwent: The Witcher Card Game",
                "added": 4978
            },
            {
                "id": 18852,
                "slug": "poker-night-at-the-inventory",
                "name": "Poker Night at the Inventory",
                "added": 2801
            },
            {
                "id": 332,
                "slug": "the-elder-scrolls-legends",
                "name": "The Elder Scrolls: Legends",
                "added": 2270
            },
            {
                "id": 8923,
                "slug": "faeria",
                "name": "Faeria",
                "added": 2220
            },
            {
                "id": 2306,
                "slug": "poker-night-2",
                "name": "Poker Night 2",
                "added": 2102
            }
        ]
    }
]
